export default function (element, data) {
    let itemsToShow = parseInt(element.getAttribute('data-show_count')) || 0;
    let items = Array.from(element.querySelectorAll('.item-block'));

    items.forEach((item, index) => {
        item.style.display = index < itemsToShow ? 'flex' : 'none';
    });

    let showMoreBtn = element.querySelector("#js-show-more");
    let hideBtn = element.querySelector("#js-hide");

    if (showMoreBtn) {
        showMoreBtn.addEventListener("click", function () {
            document.body.classList.add('no-scroll');
            items.forEach(item => {
                item.style.display = "flex";
            });

            this.style.display = "none";
            if (hideBtn) {
                hideBtn.style.display = "inline-block";
            }

            setTimeout(() => {
                document.body.classList.remove('no-scroll');
            }, 500);
        });
    }

    if (hideBtn) {
        hideBtn.addEventListener("click", function () {
            document.body.classList.add('no-scroll');
            items.forEach((item, index) => {
                if (index >= itemsToShow) {
                    item.style.display = "none";
                }
            });

            this.style.display = "none";
            if (showMoreBtn) {
                showMoreBtn.style.display = "inline-block";
            }

            setTimeout(() => {
                document.body.classList.remove('no-scroll');
            }, 500);
        });
    }
};